import { useEffect, useState } from 'react';
import moment from 'jalali-moment';
import confirm from '../../utils/confirm';
import DownloadDialog from './DownloadDialog';
import Dialog from '../../toolkit/dialog';
import storageService from '../../services/storage-service';
import { URL_ROOT } from '../../services/http-service';

const DownloadExport = () => {

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const result = await storageService.getExportsList();
    setData(result);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleDownloadItem = async (item: any) => {
    if (item.error) {
      return;
    }
    const url = URL_ROOT + item.link;
    const time = moment.from(item.createdAt, 'en').format('YYYY-MM-DD HH:mm:ss');
    new Dialog({
      rtl: true,
      size: 'small',
      title: 'دانلود پشتیبان <span class="ltr d-inline-flex">' + time + '</span>',
      message: DownloadDialog
    }).show({ url })
  }

  const handleRemoveItem = (id: string) => {
    confirm({
      title: 'آیا میخواهید این فایل را حذف کنید؟',
      type: 'error',
      primaryClass: 'ant-btn-danger',
      onSubmit: async () => {
        try {
          await storageService.removeExport(id);
          await fetchData();
        }
        catch (e) {
          confirm({ title: e.message, type: 'alert', onSubmit: () => { } });
        }
      }
    }).show()
  }

  if (data.length === 0) {
    return (
      <div className="row h-100 w-100 position-absolute">
        <div className="col-6 m-auto">
          <div className="alert alert-primary">
            شما هنوز پشتیبان گیری انجام نداده اید.
          </div>
        </div>
      </div>
    );
  }

  return (
    <ul className="download-export-cmp">
      <div className="list-header row">
        <div className="col">دیتابیس</div>
        <div className="col">تاریخ ایجاد</div>
        <div className="col">وضعیت</div>
        <div className="col">تعداد کالکشن</div>
        <div className="col">فعالیت</div>
      </div>
      {data.map(item => (
        <li key={item._id}>
          <div className="row">
            <div className="col">{item.dbname}</div>
            <div className="col ltr">
              {moment.from(item.createdAt, 'en').format('YYYY-MM-DD HH:mm:ss')}
            </div>
            <div className="col d-flex align-items-center">
              <span style={{ color: getStatusColor(item), fontWeight: 500, margin: 'auto' }}>
                {getStatusText(item)}
              </span>
            </div>
            <div className="col">{item.collections.length}</div>
            <div className="col">
              <span
                className={'action action-download' + (item.error ? ' disabled' : '')}
                onClick={handleDownloadItem.bind(this, item)}>
                <i className="fal fa-cloud-download"></i>
              </span>
              <span className="action action-remove" onClick={handleRemoveItem.bind(this, item._id)}>
                <i className="fal fa-trash-alt"></i>
              </span>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

const getStatusColor = (item: any) => {
  if (item.error) {
    return '#E74C3C';
  }
  return item.exportFinished ? '#27AE60' : '#E67E22';
}

const getStatusText = (item: any) => {
  if (item.error) {
    return 'خطا';
  }
  // Below condition is shown reverse in some editors
  return item.exportFinished ? 'اتمام' : 'در حال انجام';
}

export default DownloadExport;
